import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left Section */}
        <div className="footer-section footer-left">
          <h2 className="footer-title">Biofana foods</h2>
          <div className="footer-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaInstagram /></a>
          </div>
          <p className="footer-email">biofanafood@gmail.com</p>
        </div>

        {/* Middle Section */}
        <div className="footer-section footer-middle">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Categories</a></li>
            <li><a href="#">Products</a></li>
            <li><a href="#">Resources</a></li>
            <li><a href="#">About us</a></li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="footer-section footer-right">
          <h3>Customer Care</h3>
          <p>Online Order Queries</p>
          <p>Biofanafoods</p>
          <p>biofanafoods</p>
          <p>Timings: 9:00 a.m till 10:00 p.m</p>

          <div className="footer-input">
            <input type="email" placeholder="Enter your email" />
            <button>→</button>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
